<div class="flex-column gap-4 animated fadeIn">
    <div class="flex-column gap-4" style="max-width: 1200px;">
        <div class="flex-column gap-2">
            <span>Enter EML data here:</span>
            <div class="flex-row gap-3 align-items-start">
                <div class="flex-column f-1-0" style="max-width: 600px; flex: 1 0;">
                    <textarea type="text" style="border: 1px solid #ccc; height: 135px; border-bottom-left-radius: 0; border-bottom-right-radius: 0;"
                              [(ngModel)]="headersInputTxt"
                              [disabled]="analyzeResultInProcess"
                              placeholder="Paste here"
                              (keyup.enter)="analyzeEmail();">
                    </textarea>
                    <div class="p-2 pb-1 border border-top-0 rounded-bottom" style="border-color: #ccc !important; --bs-border-radius: 3px;">
                        <div ngfSelect
                             accept=".eml"
                             [(file)]="file"
                             (click)="file = null"
                             (fileChange)="uploadFile()">
                            <btn-c [isDisabled]="analyzeResultInProcess"
                                   class="shrunk" variant="text"
                                   endIcon="far fa-lg fa-file-medical">
                                Paste from EML file
                            </btn-c>
                        </div>
                    </div>
                </div>
                <btn-c style="width: 155px;"
                       [isDisabled]="!headersInputTxt"
                       [loading]="analyzeResultInProcess"
                       (action)="analyzeEmail();">
                    Analyze Email Headers
                </btn-c>
            </div>
        </div>
    </div>

    <hr class="animated fadeIn opacity-50" style="max-width: 1200px;" *ngIf="analyzeResult && !analyzeResultInProcess"/>

    <div class="flex-column gap-3 animated fadeIn bg-light p-3" *ngIf="analyzeResult && !analyzeResultInProcess">
        <div class="flex-row gap-3" style="max-width: 1200px;">
            <div class="flex-column border rounded-2 p-4 bg-white">
                <table class="simpleDataTableShrink" style="font-size: 14px;">
                    <tbody>
                    <tr>
                        <td><b>From</b></td>
                        <td>
                            <span *ngIf="analyzeResult.sender.name && analyzeResult.sender.email && analyzeResult.sender.name !== analyzeResult.sender.email">{{analyzeResult.sender.name}} <{{analyzeResult.sender.email}}></span>
                            <span *ngIf="!analyzeResult.sender.name || !analyzeResult.sender.email || analyzeResult.sender.name === analyzeResult.sender.email">{{analyzeResult.sender.name || analyzeResult.sender.email}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td><b>To</b></td>
                        <td>
                            <ng-container *ngFor="let recipient of analyzeResult.recipients.to; let last = last;">
                                <ng-container *ngIf="recipient.name && recipient.email && recipient.name !== recipient.email">{{recipient.name}} <{{recipient.email}}></ng-container>
                                <ng-container *ngIf="!recipient.name || !recipient.email || recipient.name === recipient.email">{{recipient.name || recipient.email}}</ng-container>
                                <ng-container *ngIf="!last">, </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                    <tr *ngIf="analyzeResult.recipients.cc?.length">
                        <td><b>Cc</b></td>
                        <td>
                            <ng-container *ngFor="let recipient of analyzeResult.recipients.cc; let last = last;">
                                <ng-container *ngIf="recipient.name && recipient.email && recipient.name !== recipient.email">{{recipient.name}} <{{recipient.email}}></ng-container>
                                <ng-container *ngIf="!recipient.name || !recipient.email || recipient.name === recipient.email">{{recipient.name || recipient.email}}</ng-container>
                                <ng-container *ngIf="!last">, </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                    <tr *ngIf="analyzeResult.recipients.bcc?.length">
                        <td><b>Bcc</b></td>
                        <td>
                            <ng-container *ngFor="let recipient of analyzeResult.recipients.bcc; let last = last;">
                                <ng-container *ngIf="recipient.name && recipient.email && recipient.name !== recipient.email">{{recipient.name}} <{{recipient.email}}></ng-container>
                                <ng-container *ngIf="!recipient.name || !recipient.email || recipient.name === recipient.email">{{recipient.name || recipient.email}}</ng-container>
                                <ng-container *ngIf="!last">, </ng-container>
                            </ng-container>
                        </td>
                    </tr>
                    <tr>
                        <td><b>Date</b></td>
                        <td>{{analyzeResult.email.received_date | date:'MM/dd/yyyy HH:mm'}}</td>
                    </tr>
                    <tr>
                        <td><b>Subject</b></td>
                        <td>{{analyzeResult.email.subject}}</td>
                    </tr>
                    <tr>
                        <td><b>Message-ID</b></td>
                        <td>{{analyzeResult.email.message_id.email}}</td>
                    </tr>
                    <tr>
                        <td><b class="text-nowrap pe-2">Return-Path</b></td>
                        <td>{{analyzeResult.email.return_path.email}}</td>
                    </tr>
                    <tr>
                        <td><b>IP Address</b></td>
                        <td>{{analyzeResult.sender.ip}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex-column border rounded-2 p-4 bg-white gap-3" style="font-size: 16px; max-width: 400px;">
                <h6>Authentication Results</h6>
                <div class="flex-row f-1-0 sss justify-content-evenly flex-wrap gap-4">
                    <ng-container *ngFor="let authResult of analyzeResult.security | keyvalue: gs.returnZero">
                        <div class="flex-row justify-content-evenly gap-2 align-items-center" style="width: 42%;">
                            <ng-container *ngIf="authResult.key !== 'reports'">
                                <span style="flex-basis: 76px;">{{authResult.key === 'compauth' ? 'CompAuth' : (authResult.key | uppercase)}}</span>
                                <div class="d-flex centralize text-white rounded-2 p-2" style="width: 80px;"
                                     [ngClass]="{'bg-success' : authResult.value.status === 'pass', 'bg-warning' : authResult.value.status !== 'pass'}">
                                    <span>{{authResult.value.status}}</span>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!--email hops table-->
        <trustifi-table-c
                *ngIf="analyzeResult.email?.hops?.length"
                class="trustifi-table border rounded-2 p-4 bg-white" style="flex: 1 0; z-index: 5; min-height: 350px; word-break: break-word;"
                [list]="analyzeResult.email.hops"
                [headers]="[
                {text: 'Submitting Host'},
                {text: 'Receiving host'},
                {text: 'Time', width: '150px'},
                {text: 'Delay', width: '100px'},
                {text: 'Type', width: '180px'},
                {text: 'Security'},
            ]"
                [cellsPrototype]="[
                {html: 'submitHostCell'},
                {html: 'receiveHostCell'},
                {html: 'timeCell'},
                {html: 'delayCell'},
                {textKey: 'with'},
                {html: 'securityCell'},
            ]"
                [options]="{
                itemsNameSingular: 'hop',
                isEllipsis: false,
            }"
        >
            <ng-template #customCells let-item let-cellId="cellId">
                <!--submit host cells-->
                <span *ngIf="cellId === 'submitHostCell'">
                    <span>
                        {{item.from.host}}
                        <ng-container *ngIf="item.from.ip">
                            <br/>
                            <span style="font-size: 12px">({{item.from.ip}})</span>
                         </ng-container>
                    </span>
                </span>

                <!--receive host cells-->
                <span *ngIf="cellId === 'receiveHostCell'">
                    <span>
                        {{item.by.host}}
                        <ng-container *ngIf="item.by.ip">
                            <br/>
                            <span style="font-size: 12px">({{item.by.ip}})</span>
                        </ng-container>
                    </span>
                </span>

                <!--time cells-->
                <span *ngIf="cellId === 'timeCell'">
                    <span>
                        {{item.time | date:'MM/dd/yyyy HH:mm:ss'}}
                    </span>
                </span>

                <!--delay cells-->
                <span *ngIf="cellId === 'delayCell'">
                    <span class="text-danger" *ngIf="item.delay > 0">
                        {{item.delay}} second{{item.delay > 1 ? 's' : ''}}
                    </span>
                    <span *ngIf="item.delay <= 0">-</span>
                </span>

                <!--security cells-->
                <span *ngIf="cellId === 'securityCell'">
                    <div class="flex-column gap-1">
                        <div class="flex-row align-items-center gap-2" *ngIf="item.secured.cipher">
                            Cipher: {{item.secured.cipher}}
                        </div>
                        <div class="flex-row align-items-center gap-2" *ngIf="item.secured.cipher">
                            Version: {{item.secured.version}}
                        </div>
                        <div class="d-flex centralize text-white rounded-2 align-self-start p-1 px-2 fw-500"
                             [ngClass]="{'bg-success' : item.secured.enabled, 'bg-warning' : !item.secured.enabled}">
                            <span>{{item.secured.enabled ? 'Secure' : 'Unsecure'}}</span>
                        </div>
                    </div>
                </span>
            </ng-template>
            <div tableButtons>
                <div class="flex-row justify-content-between">
                    <h6>Email Hops</h6>
                    <ng-container *ngIf="analyzeResult.totalHopsDelay">
                        <div class="flex-row align-items-center gap-2">
                            <span>Total hops delay: {{analyzeResult.totalHopsDelay}} second{{analyzeResult.totalHopsDelay > 1 ? 's' : ''}}</span>
                            <div class="vertical-separator opacity-50 mx-2"></div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </trustifi-table-c>

        <!--security headers table-->
        <ng-container *ngFor="let headerType of headers | keyvalue: gs.returnZero">
            <trustifi-table-c
                    *ngIf="headerType.value.length"
                    class="trustifi-table border rounded-2 p-4 bg-white" style="flex: 1 0; z-index: 5; min-height: 350px; word-break: break-word;"
                    [list]="headerType.value"
                    [headers]="[
                    {text: '', width: '200px'},
                    {text: ''},
                ]"
                    [cellsPrototype]="[
                    {textKey: 'name'},
                    {textKey: 'value'},
                ]"
                    [options]="{
                    itemsNameSingular: 'header',
                    isEllipsis: false,
                }"
            >
                <div tableButtons>
                    <h6>{{headerType.key | titlecase}} Headers</h6>
                </div>
            </trustifi-table-c>
        </ng-container>
    </div>
</div>
